module.exports = __webpack_public_path__ + "static/media/bts_veld_170805_001_small.72f97700.jpg";